import { render, staticRenderFns } from "./GotoNode.vue?vue&type=template&id=051954bc"
import script from "./GotoNode.vue?vue&type=script&lang=js"
export * from "./GotoNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports